/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ step: NonNullable<unknown> }} Order_Lot_Trace_MissingInputs */

const vi_order_lot_trace_missing = /** @type {(inputs: Order_Lot_Trace_MissingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Không có thông tin ${i?.step}`)
};

/**

* @param {Order_Lot_Trace_MissingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_lot_trace_missing = /** @type {((inputs: Order_Lot_Trace_MissingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Lot_Trace_MissingInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_lot_trace_missing(inputs)
});